import * as React from 'react';
import { EntwicklungsplanBalken } from './EntwicklungsplanBalken';

interface EntwicklungsplanSpalteMass2Props extends React.ClassAttributes<any> {
    column_position: number;
    columns_total: number;
    shifting: number;
    height_total: number;
    width_total: number;
    spalt_idx: number;
    spalten_daten: any;
    onSelect: (id: number) => void;
}

export class EntwicklungsplanSpalteMass2 extends React.Component<EntwicklungsplanSpalteMass2Props, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    private gap_bottom = 5;

    render() {
        // Infos / Daten
        const daten = this.props.spalten_daten;
        const spalt = daten[this.props.spalt_idx];

        const inherit = spalt && spalt.massnahmen2_inherit ? true : false;
        if (!spalt || inherit) {
            // Darstellung von der letzten Spalte übernehmen
            return null;
        }

        const mass2_filtered = spalt.massnahmen2 ? spalt.massnahmen2.filter((str: string) => str && str.trim() !== '') : [];
        const mass2_text = mass2_filtered.join(' #br# ');
        if (mass2_filtered.length === 0) {
            return null;
        }

        let colspan = 1;
        for (let i = this.props.spalt_idx + 1; i < daten.length; i++) {
            if (daten[i] && daten[i].massnahmen2_inherit) {
                colspan++;
            } else {
                break;
            }
        }

        // Position und Größe
        const bar_height = 50; // Höhe des orangenen balkens
        const height_reduce = (this.props.columns_total - this.props.column_position) * this.props.shifting;
        const width = this.props.width_total / this.props.columns_total;  // Breite anhand der Spaltenanzahl
        const offset_x = width * this.props.column_position;                // X-Position anhand der Spaltenanzahl
        const height_available = this.props.height_total - height_reduce;
        const height_top = (this.props.height_total * 0.6) - bar_height;
        const height_bottom = (height_available - height_top - bar_height);
        const height_year = 50 + (colspan > 1 ? 0 : this.props.spalt_idx) * 5;
        const bottom = height_year * (mass2_filtered.length > 1 ? 1 : 2);
        const height_mas2 = height_bottom - bottom;
        const shifting = this.props.shifting;
        const refStyle: CSSStyleDeclaration  = window.getComputedStyle(document.body);
        const colorInformationHilfe: string = refStyle ? refStyle.getPropertyValue('--color-main-section-informationen_hilfe') : '#84b0d6';

        return (
            <g
                onClick={() => this.props.onSelect(this.props.column_position)}
                style={{ cursor: 'pointer' }}
            >
                <EntwicklungsplanBalken
                    // width={(width - this.gap_bottom) * (colspan > 1 ? colspan - 2 / 3 : 1)}
                    width={width * colspan - this.gap_bottom}
                    height={height_mas2}
                    // offset_x={colspan === 1 ? offset_x : offset_x + (width - this.gap_bottom) / 3}
                    offset_x={offset_x}
                    // offset_y={bottom + shifting * (colspan > 1 ? colspan - 1 - 1 / 3 : 0)}
                    // offset_y={bottom + shifting * (colspan - 1)}
                    offset_y={bottom + shifting * (colspan - 1) + shifting + 10}
                    height_total={this.props.height_total}
                    color={colorInformationHilfe}
                    // color='#5d5d6f'
                    plain_base={false}
                    // shifting={shifting * (colspan > 1 ? colspan - 2 / 3 : 1)}
                    shifting={shifting * colspan}
                    text_content={mass2_text}
                    text_color='#ffffff'
                    columns_total={this.props.columns_total}
                />
            </g>
        );
    }
}
